import moment from 'moment';
import { type Timestamp } from '../services/Timestamp';

export const HttpMethods = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

export const HttpHeaders = {
  contentTypeJson: { 'Content-Type': 'application/json' },
  acceptJson: { Accept: 'application/json' },
};

export const getBearerToken = (token: string): string => `Bearer ${token}`;

export const ApiEndpoints = {
  rateApp: {
    addEventCount: '/api/rateApp/addEventCount',
    userLogin: '/api/rateApp/userLogin',
    resetRating: '/api/rateApp/resetRating',
  },
  trips: {
    getTripsPaginated: (pageNumber: number, limit: number, queryString: string): string =>
      `/api/trips/paginated/${pageNumber}/${limit}?${queryString}`,
    getEcoRatings: (queryString: string): string => `/api/trips/eco-rating?${queryString}`,
    getJobVesselTracks: (operation: string, tripId: string, jobId: string): string =>
      `/api/trips/${operation}/${tripId}/jobs/${jobId}/vessel-tracks`,
  },
  liveview: {
    getLiveviewData: (operation: string): string => `/api/liveview/${operation}`,
    getVesselTracks: (operation: string, mmsi: string): string => `/api/liveview/tracks/${operation}/${mmsi}`,
  },
  getPlaybackData: (operation: string, from: number, to: number): string => `/api/playback/${operation}/${from}/${to}`,
  tides: {
    getTides: (id: string): string => `/api/tides/${id}`,
    getTideInfo: (operation: string, timestamp: Timestamp): string =>
      `/api/tides/info/${operation}/${timestamp.toSeconds()}`,
  },
  operations: `/api/operations/`,
  getSecrets: (secretName: string): string => `/api/secrets/${secretName}`,
  settings: '/api/settings',
  vessels: {
    getVessel: (mmsi: string): string => `/api/vessels/getVessel/${mmsi}`,
  },
  search: {
    getTripsOrJobs: (searchFilter: string): string => {
      if (searchFilter) {
        return `/api/search/trips?${searchFilter}`;
      }

      return '/api/search/trips';
    },
    getVessels: (searchFilter: string): string => {
      if (searchFilter) {
        return `/api/search/vessels?${searchFilter}`;
      }

      return '/api/search/vessels';
    },
    getOperations: (searchFilter: string): string => {
      if (searchFilter) {
        return `/api/search/operations?${searchFilter}`;
      }

      return '/api/search/operations';
    },
  },
  aimFor8: {
    report: (operation: string, from: Date, to: Date): string =>
      `/api/aimFor8Report/${operation}/${moment(from).format('YYYY-MM-DDT00:00:00')}/${moment(to).format(
        'YYYY-MM-DDT23:59:59'
      )}`,
  },
};
